import cn from 'classnames';
import * as React from 'react';

import classes from './List.module.scss';
import { ListProps } from './List.types';

export const List = ({ classes: receivedClasses = {}, children }: ListProps) => (
    <ul className={cn(classes.root, receivedClasses.root)}>{children}</ul>
);
